module.exports = "https://cdn.realtymogul.com/static/media/img_panel_PP.d67e079e.jpg";